import React, {useState, useEffect} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {Panel} from "primereact/panel";
import {Button} from 'primereact/button';
import {BlockUI} from "primereact/blockui";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import FormLocker from "../../util/FormLocker";
import axios from "axios";
import Cookies from "js-cookie";

import HelpComponent from "../HelpComponent";
import moment from "moment/moment";
import {InputSwitch} from "primereact/inputswitch";
import {Checkbox} from "primereact/checkbox";
import {Tooltip} from "primereact/tooltip";

const _FM_AccommodationpreparationFormComponent = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action} = useParams();
  const [formData, setFormData] = useState({});
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState('');
  const [loading, setLoading] = useState(false);
  const [locking, setLocking] = useState(false);

  FormLocker(() => {
    if (formData && formData.id && formData._class_name) {
      window.App.formLock(formData._class_name, formData.id)
    }
  }, 1000);

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task-list/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          if (response.data && response.data.data && response.data.data.under_edit_from
            && response.data.data.under_edit_by !== Number(Cookies.get('userId'))) {
            setLocking(true)
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    window.App.setState({rerenderAccommodationpreparationForm: false})
  }, [window.App.state.rerenderAccommodationpreparationForm === true])

  return (
    <>
      <BlockUI blocked={locking} className="blocked-ui-overlay" template={<div className="blocked-ui-message"><i className="pi pi-exclamation-triangle blocked-ui-message-icon" aria-hidden="true"></i>{t("module_editing_after_save_only")}</div>}>
        <h2 className={"p-mb-0"}>
          {formData.name || t('accommodationpreparation_show')}
          <span style={{float: 'right', fontSize: '1rem'}} className={"p-text-normal p-mt-1"}>
          #{formData.id}
        </span>
        </h2>
        <div className={"p-grid"} style={{clear: 'both'}}>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('residential_unit')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {formData?.residential_unit?.name}
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('reservation')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {formData?.reservation?.association_code &&
                <>
                  <span className={"tt-association-code-accommodation-form-info-" + formData?.reservation?.id + " p-mr-2"}
                        data-pr-tooltip={formData?.reservation?.association_code}>
                    <i className={"pi pi-info-circle"} style={{fontSize: '0.85rem', color: '#6c757d', cursor: 'pointer'}}></i>
                  </span>
                  <Tooltip target={".tt-association-code-accommodation-form-info-" + formData?.reservation?.id}/>
                  <span className={"p-badge"}
                        style={{
                          fontSize: '1rem',
                          backgroundColor: formData?.reservation?.status
                            ? formData?.reservation?.status?.toLowerCase() === 'pending'
                              ? '#dddddd'
                              : formData?.reservation?.status?.toLowerCase() === 'confirmed'
                                ? '#f1eea5'
                                : formData?.reservation?.status?.toLowerCase() === 'cancelled'
                                  ? '#f7a2a2'
                                  : formData?.reservation?.status?.toLowerCase() === 'checked_in'
                                    ? '#3ec0e9'
                                    : formData?.reservation?.status?.toLowerCase() === 'checked_out'
                                      ? '#0abb87'
                                      : formData?.reservation?.status?.toLowerCase() === 'no_show'
                                        ? '#8a2be2'
                                        : '#ccc'
                            : undefined,
                          color: formData?.reservation?.status
                            ? formData?.reservation?.status?.toLowerCase() === 'pending' || formData?.reservation?.status?.toLowerCase() === 'confirmed'
                              ? '#5f656b'
                              : formData?.reservation?.status?.toLowerCase() === 'no_show'
                                ? '#fff'
                                : undefined
                            : undefined
                  }}>
                    {formData?.reservation?.association_code?.split(' | ').pop()?.trim()}
                  </span>
                </>
              }
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('created_at')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
            </p>
          </div>
          <div className={"p-col"}>
            <small className={"p-text-uppercase"}>
              {t('updated_at')}
            </small>
            <p className={"p-mt-0 p-mb-0 p-text-bold"}>
              {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
            </p>
          </div>
          <div className={"p-col p-text-right p-col-align-center"} style={{maxWidth: '60px'}}>
            <Button type="button"
                    icon={"pi pi-times"}
                    onClick={() => {
                      navigate(-1)
                    }}
                    className="p-button-secondary close p-ml-2">
            </Button>
          </div>
        </div>
        <Panel className={"p-mt-3"}>
          <div className={"p-grid"}>
            <div className={"p-col"}>
              <h3 className={"p-m-0"}>{t('accommodationpreparation_form')}</h3>
            </div>
            <div className={"p-col p-text-right p-col-align-center"}>
            </div>
          </div>
          {/*<HelpComponent type={"site"} position={"IN_ACTIVE_BOX"}/>*/}
          <HelpComponent type={"edit_box"}/>
          {formData.tasks && formData.tasks[0] &&
            <>
              {formData.tasks.map((task, index) => {
                return (
                  <div className={"p-grid"}>
                    <div className={"p-col-2 p-lg-1 p-col-align-center"}>
                      <Checkbox onChange={(e) => {
                        console.log(e)
                        axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task/" + task.id,
                          {
                            is_done: e.checked
                          },
                          {
                            params: {},
                            headers: {
                              'Authorization': 'Bearer ' + Cookies.get("userToken"),
                              "Sys-name": Cookies.get("instanceId"),
                              "Preferred-locale": Cookies.get("language")
                            }
                          })
                          .then(response => {
                            axios({
                              method: 'get',
                              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task-list/" + id,
                              params: {},
                              headers: {
                                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                                "Sys-name": Cookies.get("instanceId"),
                                "Preferred-locale": Cookies.get("language")
                              }
                            })
                              .then(response => {
                                setFormData(response.data.data);
                                window.App.setState({rerenderAccommodationpreparationList: true})
                              })
                              .catch(error => {
                                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                setLoading(false)
                              })
                          })
                          .catch(error => {
                            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                          })
                      }}
                                checked={task.is_done}>
                      </Checkbox>
                      {/*<InputSwitch*/}
                      {/*  className={""}*/}
                      {/*  name={task.name}*/}
                      {/*  checked={task.is_done}*/}
                      {/*  onChange={(e) => {*/}
                      {/*    axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task/" + task.id,*/}
                      {/*      {*/}
                      {/*        is_done: e.value*/}
                      {/*      },*/}
                      {/*      {*/}
                      {/*        params: {},*/}
                      {/*        headers: {*/}
                      {/*          'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
                      {/*          "Sys-name": Cookies.get("instanceId"),*/}
                      {/*          "Preferred-locale": Cookies.get("language")*/}
                      {/*        }*/}
                      {/*      })*/}
                      {/*      .then(response => {*/}
                      {/*        axios({*/}
                      {/*          method: 'get',*/}
                      {/*          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "accommodation-preparation-task-list/" + id,*/}
                      {/*          params: {},*/}
                      {/*          headers: {*/}
                      {/*            'Authorization': 'Bearer ' + Cookies.get("userToken"),*/}
                      {/*            "Sys-name": Cookies.get("instanceId"),*/}
                      {/*            "Preferred-locale": Cookies.get("language")*/}
                      {/*          }*/}
                      {/*        })*/}
                      {/*          .then(response => {*/}
                      {/*            setFormData(response.data.data);*/}
                      {/*            window.App.setState({rerenderAccommodationpreparationList: true})*/}
                      {/*          })*/}
                      {/*          .catch(error => {*/}
                      {/*            window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
                      {/*            setLoading(false)*/}
                      {/*          })*/}
                      {/*      })*/}
                      {/*      .catch(error => {*/}
                      {/*        window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
                      {/*      })*/}
                      {/*  }}/>*/}
                    </div>
                    <div className={"p-col-10 col-lg-11 p-col-align-center"}>
                      {task.name}
                    </div>
                  </div>
                )
              })}
            </>
          }
        </Panel>
      </BlockUI>
      {locking === true &&
        <div className={"p-mt-2"}>
          <i className={"pi pi-exclamation-circle"}></i>
          &nbsp;
          {t('form_under_edit')}
          {formData && formData.under_edit_by_name_snap &&
            <>&nbsp;{t('form_under_edit_by')}: {formData.under_edit_by_name_snap}</>
          }
        </div>
      }
    </>
  )
}
export default withTranslation('common')(_FM_AccommodationpreparationFormComponent);
